import React from 'react';

export default function AdvancedFilters({ filters, setFilters, dropdownData, breeds }) {
  const handleMultiSelect = (e, field) => {
    const values = Array.from(e.target.selectedOptions, (opt) => opt.value);
    setFilters((prev) => ({ ...prev, [field]: values }));
  };

  const toggleCheckboxArrayValue = (field, value) => {
    const current = filters[field] || [];
    const updated = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];
    setFilters((prev) => ({ ...prev, [field]: updated }));
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-4">
      {/* Breed: Checkboxes */}
      <div>
        <p className="font-montserrat font-bold mb-1">Breed</p>
        <div className="max-h-32 overflow-y-auto border rounded p-2 space-y-1">
          {breeds.map((b) => (
            <label key={b._id} className="block text-sm">
              <input
                type="checkbox"
                checked={filters.breed?.includes(b._id)}
                onChange={() => toggleCheckboxArrayValue('breed', b._id)}
                className="mr-2 font-montserrat"
              />
              {b.name}
            </label>
          ))}
        </div>
      </div>


      {/* Color: Checkboxes */}
      <div>
        <p className="font-montserrat font-bold mb-1">Color</p>
        <div className="max-h-32 overflow-y-auto border rounded p-2 space-y-1">
          {(dropdownData.color || []).map((color) => (
            <label key={color} className="block text-sm">
              <input
                type="checkbox"
                checked={filters.color?.includes(color)}
                onChange={() => toggleCheckboxArrayValue('color', color)}
                className="font-montserrat mr-2"
              />
              {color}
            </label>
          ))}
        </div>
      </div>

      {/* Sex: Checkboxes */}
      <div>
        <p className="font-montserrat font-bold mb-1">Sex</p>
        <div className="max-h-32 overflow-y-auto border rounded p-2 space-y-1">
          {(dropdownData.sex || []).map((sex) => (
            <label key={sex} className="block text-sm">
              <input
                type="checkbox"
                checked={filters.sex?.includes(sex)}
                onChange={() => toggleCheckboxArrayValue('sex', sex)}
                className="font-montserrat mr-2"
              />
              {sex}
            </label>
          ))}
        </div>
      </div>

      {/* Discipline: Checkboxes */}
      <div>
        <p className="font-montserrat font-bold mb-1">Discipline</p>
        <div className="max-h-32 overflow-y-auto border rounded p-2 space-y-1">
          {(dropdownData.discipline || []).map((discipline) => (
            <label key={discipline} className="block text-sm">
              <input
                type="checkbox"
                checked={filters.discipline?.includes(discipline)}
                onChange={() => toggleCheckboxArrayValue('discipline', discipline)}
                className="mr-2 font-montserrat"
              />
              {discipline}
            </label>
          ))}
        </div>
      </div>

      {/* Number & text inputs */}

      {/* Price */}
      <div>
      <h2 className="font-montserrat font-bold">Price</h2>
      <div className="flex flex-row gap-2">
      <input
        name="minPrice"
        type="text"
        placeholder="Min Price"
        value={filters.minPrice}
        onChange={(e) => setFilters((prev) => ({ ...prev, minPrice: e.target.value }))}
        className="border p-2 rounded w-1/2"
      />
      <input
        name="maxPrice"
        type="text"
        placeholder="Max Price"
        value={filters.maxPrice}
        onChange={(e) => setFilters((prev) => ({ ...prev, maxPrice: e.target.value }))}
        className="border p-2 rounded w-1/2"
      />
      </div>
    </div>

    {/* Height */}
    <div>
      <h2 className="font-montserrat font-bold">Height</h2>
      <div className="flex flex-row gap-2">
      <input
        name="minHeight"
        type="text"
        placeholder="Min Height (hh)"
        value={filters.minHeight}
        onChange={(e) => setFilters((prev) => ({ ...prev, minHeight: e.target.value }))}
        className="border p-2 rounded w-1/2"
      />
      <input
        name="maxHeight"
        type="text"
        placeholder="Max Height (hh)"
        value={filters.maxHeight}
        onChange={(e) => setFilters((prev) => ({ ...prev, maxHeight: e.target.value }))}
        className="border p-2 rounded w-1/2"
      />
      </div>
    </div>
    
    {/* Age */}
    <div>
      <h2 className="font-montserrat font-bold">Age</h2>
      <div className="flex flex-row gap-2">
        <input
          name="minAge"
          type="text"
          placeholder="Min Age"
          value={filters.minAge}
          onChange={(e) => setFilters((prev) => ({ ...prev, minAge: e.target.value }))}
          className="border p-2 rounded w-1/2"
        />
        <input
          name="maxAge"
          type="text"
          placeholder="Max Age"
          value={filters.maxAge}
          onChange={(e) => setFilters((prev) => ({ ...prev, maxAge: e.target.value }))}
          className="border p-2 rounded w-1/2"
        />
      </div>
    </div>

      {/* Checkboxes */}
      <div className="flex flex-row gap-12">
      <label className="inline-flex items-center font-montserrat">
        <input
          type="checkbox"
          checked={filters.vetCheck}
          onChange={(e) => setFilters((prev) => ({ ...prev, vetCheck: e.target.checked }))}
          className="mr-2"
        />
        Vet Check Verified
      </label>

      <label className="inline-flex items-center font-montserrat">
        <input
          type="checkbox"
          checked={filters.verifiedSeller}
          onChange={(e) => setFilters((prev) => ({ ...prev, verifiedSeller: e.target.checked }))}
          className="mr-2 font-montserrat"
        />
        Verified Seller
      </label>
   </div> 
  </div>

  );
}